import { RoomInput } from '../__generated__/api';

export const getAdultsAndChildrenFromRooms = (rooms: RoomInput[]) => ({
  adults: getAdultsFromRooms(rooms),
  children: getChildrenFromRooms(rooms),
});

export const getAdultsFromRooms = (rooms: RoomInput[]) =>
  rooms
    .map(room => room.adults)
    .filter(adult => adult > 0)
    .join(',');

export const getChildrenFromRooms = (rooms: RoomInput[]) =>
  rooms
    .map((room, index) => convertRoomChildrenToString(index + 1, room.children?.map(child => child.age) || []))
    .filter(child => child !== '')
    .join(',');

export const convertRoomChildrenToString = (roomNumber: number, ages: number[]): string => {
  const result: string = ages.map((age: number) => `${roomNumber}_${age}`).join(',');

  return result;
};
